import { Modal, Box, Button, Typography } from '@mui/material'
import { useSoundPermission } from '../../context/AllowContext'

const ModalAllowSound = () => {
    const { isModalOpen, allowSound } = useSoundPermission()

    return (
        <Modal open={isModalOpen}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 350,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 4,
                    textAlign: 'center',
                }}
            >
                <Typography variant='h6' mb={2}>
                    Sound Notification Permission
                </Typography>
                <Typography variant='body1' mb={3}>
                    To ensure you receive important real-time alerts, please
                    enable audio playback functionality.
                </Typography>
                <Button
                    variant='contained'
                    color='primary'
                    onClick={allowSound}
                >
                    Allow Sound
                </Button>
            </Box>
        </Modal>
    )
}

export default ModalAllowSound
